import { Button } from "antd";
import { CustomIcon } from "datastake-daf/dist/components";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "../..";
import i18next from "i18next";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function TazamaExtraButtons({ isHomePage }) {
  const { t } = useTranslation();
  const [toggled, setToggled] = useState(false);

  return (
    <>
      <div className="flex tazama-extra desktop">
        <Link to={isHomePage && BASE_URL ? `${BASE_URL}/login?language=${i18next.language}` : '/login'}>
          <Button type="link" className="btn-text">
            {t('Log In')}
          </Button>
        </Link>
        <Link to={isHomePage && BASE_URL ? `${BASE_URL}/register?language=${i18next.language}` : '/register'}>
          <Button type="primary" className="btn-secondary">
            {t('Sign Up')}
          </Button>
        </Link>
      </div>

      <div className="flex tazama-extra mobile">
        <div
          onClick={() => setToggled(p => !p)}
          className="cursor-pointer p-1 flex flex-column justify-content-center">
          <CustomIcon name="NavToggle" width={15} height={10} />
        </div>

        <div className={formatClassname(['nav-extra', toggled && 'toggled'])}>
          <Navbar app="tazama" onClose={() => setToggled(p => !p)} />
          <div className="p-6">
            <Link to="/register">
              <Button type="primary" className="btn-secondary w-100 mb-3">
                {t('Sign Up')}
              </Button>
            </Link>

            <Link to="/login">
              <Button className="w-100">
                {t('Log In')}
              </Button>
            </Link>
          </div>

        </div>
      </div>
    </>
  )
}
